import { useNavigate } from 'react-router-dom';
import { siteMeta, categories, tagCloud } from '../../mocks/site';

export default function SiteFooter() {
  const navigate = useNavigate();

  return (
    <footer className="bg-accent-100/60 text-foreground-800">
      <div className="container-x grid grid-cols-1 gap-8 py-12 md:grid-cols-12 md:py-14">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-lg text-background-50">
              <i className="ri-archive-fill"></i>
            </span>
            <span className="font-display text-xl font-bold text-foreground-900">{siteMeta.name}</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
            专注娱乐圈陈年旧瓜与历史爆料的考古重读站。我们旧事重提，把尘封往事重新翻开，
            在时间线的起点寻找当年真相与那些被忽略的反转。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="text-xs text-foreground-500">跟随我们</span>
            <div className="flex items-center gap-2">
              <a
                href="#"
                aria-label="微博"
                rel="nofollow"
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                aria-label="微信公众号"
                rel="nofollow"
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                aria-label="哔哩哔哩"
                rel="nofollow"
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-600 hover:text-background-50"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <nav className="md:col-span-3" aria-label="栏目导航">
          <h4 className="font-display text-sm font-bold text-foreground-900">栏目档案</h4>
          <ul className="mt-4 grid grid-cols-2 gap-2.5 md:grid-cols-1">
            {categories.map((c) => (
              <li key={c.slug}>
                <button
                  onClick={() => navigate(`/column/${c.slug}`)}
                  className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {c.name}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-4">
          <h4 className="font-display text-sm font-bold text-foreground-900">热门考古话题</h4>
          <div className="mt-4 flex flex-wrap gap-2">
            {tagCloud.slice(0, 8).map((t) => (
              <span
                key={t.name}
                className="cursor-pointer rounded-full border border-background-300/70 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-700"
              >
                {t.name}
              </span>
            ))}
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-foreground-600">
            <a href="mailto:tougao@guzhiguadang.example.com" className="inline-flex items-center gap-1.5">
              <i className="ri-mail-line"></i>投稿：{siteMeta.email}
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {siteMeta.name} · 故纸瓜档内容站 保留所有权利</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-emotion-happy-line"></i>旧事重提，重新解读当年真相
          </p>
        </div>
      </div>
    </footer>
  );
}